<template>
  <div id="right-bottom">
    <div>
      <div class="d-flex pt-2 pl-2">
        <div class="d-flex">
          <!-- <span class="fs-xl text mx-2">普拉托科技公司近期每月资产购置</span> -->
        </div>
      </div>
      <div>
        <chart :echartData="screenData" />
      </div>
    </div>
  </div>
</template>

<script>
import chart from "./chart";
export default {
  props: {
    screenData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  watch: {
    screenData: {
      handler: function (newData) {
        this.screenData = newData;
      },
      immediate: true,
      deep: true, //深度监听设置为 true
    },
  },
  components: {
    chart,
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
$box-height: 230px;
$box-width: 100%;
#right-bottom {
  padding: 0px 16px 0 16px;
  height: $box-height;
  width: $box-width;
  border-radius: 5px;
  .bg-color-black {
    padding: 4px 0 0 4px;
    height: $box-height - 35px;
    border-radius: 10px;
  }
  .text {
    color: #c3cbde;
  }
}
</style>